<template>
  <div>
    <a-form-model class="basic" :model="form" :rules="rules" ref="baseForm">
      <a-collapse
        :bordered="true"
        expand-icon-position="right"
        :activeKey="['1', '2', '3', '4']"
        class="detail-collapse"
      >
        <!-- ===================== 房源基本信息 ===================== -->
        <a-collapse-panel key="1">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                房源基本信息
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <BasicInfo
              :form="form"
              :housingAddressString="housingAddressString"
              :isEditable="isEditable"
            ></BasicInfo>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 资产信息 ===================== -->
        <a-collapse-panel key="2">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                资产信息
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <AssetInfo
              :selectRightList="selectRightList"
              ref="assetInfo"
            ></AssetInfo>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 房源属性信息 ===================== -->
        <a-collapse-panel key="3">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                房源属性信息
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <PropertyAttribute
              :form="form"
              :isEditable="isEditable"
            ></PropertyAttribute>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 上传附件 ===================== -->
        <a-collapse-panel key="4">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                上传附件
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <Attachment :form="form" :isEditable="isEditable"></Attachment>
          </a-spin>
        </a-collapse-panel>
      </a-collapse>
    </a-form-model>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import BasicInfo from "./basicInfo/BasicInfo";
import AssetInfo from "./assetInfo/AssetInfo";
import PropertyAttribute from "./propertyAttribute/PropertyAttribute";
import Attachment from "./attachment/Attachment";
import { submitResource, getResourceDetail } from "@/api/property/Property.js";
import { scrollToTop, emptyToUndefined } from "@/utils/util";
export default {
  props: {
    isEditable: {
      type: Boolean,
      default: () => true,
    },
    webId: {
      type: String,
      default: () => undefined,
    },
    selectRightList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BasicInfo,
    AssetInfo,
    PropertyAttribute,
    Attachment,
  },
  data() {
    return {
      spinning: false,
      form: {
        //父层传值
        otype: 0,
        webId: undefined,
        //房源基本信息
        housingResName: undefined,
        housingResCode: undefined,
        housingResAddress: undefined,

        //权证ID集合用于构建房源的权证ID集合，一个房源可以关联多个权证。修改时可不传
        assetCertificateIds: this.selectRightList,

        //房源属性信息
        houseStatus: undefined,
        housingStatusOtherDesc: undefined,
        leaseArea: undefined,
        leaseExpireTime: undefined,
        leaseUseType: [],
        leaseUse: undefined,
        // 地址映射
        housingResProvinceCode: undefined,
        housingResCityCode: undefined,
        housingResRegionCode: undefined,
        //上传附件
        attachement: [
          {
            id: 1,
            type: "房源封面(至少1张)",
            files: [],
            uploadType: 201,
          },
          {
            id: 2,
            type: "房源图片(至少2张)",
            files: [],
            uploadType: 202,
          },
        ],
      },
      //用于后端返回值
      housingAddressString: undefined,
      rules: {
        housingResName: [{ required: true, message: "请输入房源名称" }],
        housingResCode: [
          { required: true, message: "请选择房源所在省/市/区(县)" },
        ],
        housingResAddress: [{ required: true, message: "请输入详细地址" }],

        houseStatus: [{ required: true, message: "请选择房屋状态" }],
        housingStatusOtherDesc: [
          { required: true, message: "请输入房屋状态其他说明" },
        ],
        leaseArea: [
          // 只在提交时必填
          { required: true, message: "请输入权证面积", trigger: "blur" },

          // blur 时：允许为空；不为空则校验数字与范围
          {
            validator: (rule, value, callback) => {
              // 1) 为空直接通过（保存时允许为空；提交的必填交给上面 required）
              if (value === undefined || value === null || value === "") {
                callback();
                return;
              }
              // 2) 非数字
              // 注意：value 可能是字符串，所以用 Number 转一下更稳
              const num = Number(value);
              if (Number.isNaN(num)) {
                callback(new Error("权证面积必须为数字"));
                return;
              }
              // 3) 范围
              if (num < 0) {
                callback(new Error("权证面积必须大于等于0"));
                return;
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        leaseExpireTime: [
          { required: true, message: "请选择租赁期限届满时间" },
        ],
        leaseUseType: [{ required: true, message: "请选择租赁用途" }],
        leaseUse: [{ required: true, message: "请输入租赁租赁用途其他说明" }],
      },
    };
  },

  mounted() {
    if (this.webId && this.webId.trim() !== "") {
      this.spinning = true;
      getResourceDetail({ webId: this.webId })
        .then((res) => {
          if (res && res.code === "200") {
            const baseInfo = res.data.baseInfo;
            this.form.otype = 1;
            this.form.webId = emptyToUndefined(baseInfo.webId);
            this.form.housingResName = emptyToUndefined(
              baseInfo.housingResName
            );
            this.form.housingResAddress = emptyToUndefined(
              baseInfo.housingResAddress
            );
            this.form.houseStatus = emptyToUndefined(baseInfo.houseStatus);
            this.form.housingStatusOtherDesc = emptyToUndefined(
              baseInfo.housingStatusOtherDesc
            );
            this.form.leaseArea = emptyToUndefined(baseInfo.leaseArea);
            this.form.leaseExpireTime = emptyToUndefined(
              baseInfo.leaseExpireTime
            );
            this.form.leaseUseType = emptyToUndefined(baseInfo.leaseUseType);
            this.form.leaseUse = emptyToUndefined(baseInfo.leaseUse);
            //前端展示地理位置信息
            this.form.housingResCode = [
              baseInfo.housingResProvinceCode,
              baseInfo.housingResCityCode,
              baseInfo.housingResRegionCode,
            ].filter(Boolean);
            this.housingAddressString = emptyToUndefined(
              baseInfo.housingAddressString
            );
            //房源封面
            this.form.attachement.find(
              (item) => item.uploadType === 201
            ).files = res.data.housingCover.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.housingCoverUrl,
              };
            });
            //房源图片
            this.form.attachement.find(
              (item) => item.uploadType === 202
            ).files = res.data.housingPicture.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.housingPictureUrl,
              };
            });
          } else {
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          //缓冲转圈
          this.spinning = false;
        });
    }
  },

  methods: {
    /** 提交前校验 */
    async beforeSubmit() {
      const valid = await new Promise((resolve) => {
        this.$refs.baseForm.validate((valid) => {
          resolve(valid);
        });
      });

      if (!valid) {
        this.$notification.warning({
          message: "注意",
          description: "请先完善房源信息",
          duration: 4,
        });
        return false;
      }

      // 1. 校验“房源封面”是否上传
      const housingCover = this.form.attachement.find(
        (item) => item.uploadType === 201
      );

      if (!housingCover || this.getUploadedFiles(housingCover).length === 0) {
        this.$notification.warning({
          message: "注意",
          description: "请上传1张房源封面",
          duration: 4,
        });
        return false;
      }

      // 1. 校验“房源图片”是否上传
      const housingPicture = this.form.attachement.find(
        (item) => item.uploadType === 202
      );

      if (!housingPicture || this.getUploadedFiles(housingPicture).length < 2) {
        this.$notification.warning({
          message: "注意",
          description: "请上传至少2张房源图片",
          duration: 4,
        });
        return false;
      }

      // 2.校验房源权证状态（是否处于审批中）
      if (this.$refs.assetInfo.validWarrantAuditStatus()) {
          this.$notification.warning({
            message: `注意`,
            description: `存在部分权证尚未审核通过，请审核通过后再提交房源信息`,
          });

        return false;
      }
      return true;
    },

    /** 提交（强校验） */
    async handleSubmit() {
      try {
        // 将权证地址映射成
        const housingResCode = this.form.housingResCode || [];
        this.form.housingResProvinceCode = housingResCode[0] || undefined;
        this.form.housingResCityCode = housingResCode[1] || undefined;
        this.form.housingResRegionCode = housingResCode[2] || undefined;

        // 房源封面（201）
        const housingCoverList = this.form.attachement
          .filter((item) => item.uploadType === 201)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 房源图片（202）
        const housingPictureList = this.form.attachement
          .filter((item) => item.uploadType === 202)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        const res = await submitResource({
          ...this.form,
          //附件文件
          housingCoverList,
          housingPictureList,
        });
        if (!res || res.code !== "200") {
          this.$notification.warning({
            message: "提交失败",
            description: res.msg || "提交房源失败",
          });
          return false;
        }
        setTimeout(() => {
          this.$notification.success({
            message: `提交房源`,
            description: `成功`,
          });
          this.$emit("back");
          //滚动到最上方
          this.$nextTick(() => {
            scrollToTop(this, 80);
          });
        }, 200);
        return true;
      } catch (err) {
        console.error("接口调用异常：", err);

        this.$notification.warning({
          message: "提交失败",
          description: err?.message || "接口异常",
        });

        return false;
      }
    },

    //获取上传文件信息
    getUploadedFiles(record) {
      if (!record.files || !record.files.length) return [];
      return record.files.filter((f) => f.status === "done");
    },
  },
};
</script>

<style scoped>
.detail-collapse {
  background: #fff;
}
.detail-collapse /deep/ .ant-collapse-header {
  font-size: 15px;
  font-weight: bold;
}
.detail-collapse /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}
::v-deep .detail-collapse .ant-form-item {
  margin-bottom: 4px !important; /* 自己改 */
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
